import {saveAs} from 'file-saver-es';

import {DeviceOSType} from '@shared-types';

export function downloadBlob(blob: Blob, fileName: string, deviceType: DeviceOSType = 'android') {
	if (deviceType === 'ios') {
		saveAs(blob, `${fileName}`); //${Date.now().toString()}
	} else {
		const link = document.createElement('a');
		link.href = URL.createObjectURL(blob);

		link.download = `${fileName}`;
		link.click();
	}
}
